import styled from 'styled-components'

import { PageNavUnstyled } from './unstyled'

export const PageNav = styled(PageNavUnstyled)`
  min-height: 60px;
  border-bottom: 1px solid ${props => props.theme.colors.iron};
  background-color: ${props => props.theme.colors.white};
  padding-left: 17px;
`

export * from './PageNavItem'
